import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKey as aansluitingQueryKey } from '../../aansluiting/contractinstellingen/hooks/useLabelsSearch'
import { queryKey as hoofdleidingQueryKey } from '../../hoofdleiding/contractinstellingen/hooks/useLabelsSearch'
import { useAlerts } from '../../theme/hooks/useAlerts'
import { queryKey as hoofdleidingContextListsQueryKey } from '../../valuelists/hooks/useHoofdleidingContextLists'
import { queryKey as hoofdleidingOrganisationListsQueryKey } from '../../valuelists/hooks/useHoofdleidingOrganisationLists'
import { deleteLabel } from '../services/deleteLabel'

export { useDeleteLabel }

const useDeleteLabel = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: deleteLabel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [aansluitingQueryKey] })
      queryClient.invalidateQueries({ queryKey: [hoofdleidingQueryKey] })
      queryClient.invalidateQueries({
        queryKey: hoofdleidingOrganisationListsQueryKey,
      })
      queryClient.invalidateQueries({
        queryKey: hoofdleidingContextListsQueryKey,
      })
      successAlert('Label succesvol verwijderd')
    },
  })
}
